import React from "react";

function EvaPulsatingHead({ audioVolume }) {
  const boundedVolume = Math.max(0, Math.min(Number(audioVolume) || 0, 100));
  const scale = 1 + (boundedVolume / 120);
  return (
    <img
      src="https://nzbukggxgocbupparhnl.supabase.co/storage/v1/object/public/public-images//Eva.png"
      alt="Eva"
      className="pulsating-head"
      style={{
        transform: `scale(${scale})`,
        transition: 'transform 0.08s ease-out',
      }}
    />
  );
}

export default EvaPulsatingHead;
